import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
// 删除本地Bootstrap引用
// 注意：不再使用本地引用，将在public/index.html中通过CDN加载

const app = createApp(App)
app.use(router)
app.mount('#app')
